/**
 * Performs an enrollment and syncing of points for the user in the loyalty program
 *
 * @param {string} siteId - The site ID to use for the enrollment
 * @param {function} onSuccess - Callback function to call when the enrollment and syncing is successful
 *
 */
export const enrollmentFetch = async (siteId, onSuccess) => {
    const urlEnroll = `/on/demandware.store/Sites-${siteId}-Site/default/LoyaltyProgram-Enroll?rurl=3`
    const urlSyncPoints = `/on/demandware.store/Sites-${siteId}-Site/default/LoyaltyProgram-SyncPoints`

    try {
        const enrollResponse = await fetch(urlEnroll)
        const enrollData = await enrollResponse.json()

        if (enrollResponse.ok && !enrollData.error) {
            const syncPointsResponse = await fetch(urlSyncPoints)
            const syncPointsData = await syncPointsResponse.json()

            if (syncPointsResponse.ok && syncPointsData.success) {
                return onSuccess()
            } else {
                console.error('Sync Points API call failed:', syncPointsData)
            }
        } else {
            console.error('Enroll API call failed:', enrollData)
        }
    } catch (error) {
        console.error('Error during enrollment or syncing points:', error)
    }
}
